const LIPS = "lips";
const EYES = "eyes";
const FACE = "face";
const PRESET = "preset";
export const SECTIONS = [LIPS, EYES, FACE, PRESET];
